export default {
  workbench: {
    attendance: "考勤相关",
    punch: "打卡",
    makeupPunch: "补卡",
    leave: "请假",
    overtime: "加班",
    hrManagement: "人事管理",
    recruitment: "招聘需求申请",
    becomeRegular: "转正申请",
    transfer: "调岗申请",
    salaryAdjustment: "薪资调整申请",
    financeManagement: "财务管理",
    payment: "付款申请",
    reimbursement: "费用报销",
    purchase: "采购申请",
    pettyCash: "备用金申请",
    noPermission: "暂无权限，如需使用该功能，请联系管理员开通"
  }
}
